function ngLocaleRoot() {
  var lang = (document.documentElement.lang || "da").toLowerCase().split("-")[0];
  if (lang === "da") return "/da-dk/";
  return "/" + lang + "/";
}
function ngT(en, tr, da) {
  var lang = (document.documentElement.lang || 'da').toLowerCase().split('-')[0];
  if (lang === 'en') return en;
  if (lang === 'tr') return tr;
  return da;
}
/* Search Overlay — Live search via Section Rendering API */
(function() {
  var overlay = document.getElementById('ng-search-overlay');
  var backdrop = document.getElementById('ng-search-backdrop');
  var input = document.getElementById('ng-search-input');
  var closeBtn = document.getElementById('ng-search-close');
  var triggers = document.querySelectorAll('.ng-search-trigger');
  var defaultContent = document.getElementById('ng-search-default');
  var clearBtn = document.getElementById('ng-search-clear');

  if (!overlay) return;

  // Create results container
  var resultsDiv = document.createElement('div');
  resultsDiv.id = 'ng-search-results';
  resultsDiv.className = 'ng-search-overlay__body ng-hidden';
  resultsDiv.innerHTML = '<div class="ng-search-overlay__body-inner">' +
    '<div class="ng-search__results-header">' +
    '<p class="ng-search__section-label">' + ngT('Products (', 'Ürünler (', 'Produkter (') + '<span id="ng-search-results-count">0</span>)</p>' +
    '<a href="/search?q=&type=product" id="ng-search-results-link" class="ng-search__results-all">Se alle resultater' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>' +
    '</div>' +
    '<div id="ng-search-results-products" class="ng-search__results-grid"></div>' +
    '</div>';
  defaultContent.parentNode.insertBefore(resultsDiv, defaultContent.nextSibling);

  // Create no-results container
  var noResultsDiv = document.createElement('div');
  noResultsDiv.id = 'ng-search-no-results';
  noResultsDiv.className = 'ng-search-overlay__body ng-hidden';
  noResultsDiv.innerHTML = '<div class="ng-search-overlay__body-inner" style="text-align:center;padding:64px 0;">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e5e7eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin:0 auto 16px"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
    '<p style="font-size:15px;font-weight:500;color:#9ca3af;margin-bottom:8px;">' + ngT('No results for &ldquo;', 'Sonuç yok &ldquo;', 'Ingen resultater for &ldquo;') + '<span id="ng-search-no-results-query"></span>&rdquo;</p>' +
    '<p style="font-size:12px;color:#d1d5db;">' + ngT('Try another search term or explore our categories', 'Başka bir arama terimi deneyin veya kategorilerimize göz atın', 'Prøv et andet søgeord eller udforsk vores kategorier') + '</p>' +
    '</div>';
  resultsDiv.parentNode.insertBefore(noResultsDiv, resultsDiv.nextSibling);

  var resultsProducts = document.getElementById('ng-search-results-products');
  var resultsCount = document.getElementById('ng-search-results-count');
  var resultsLink = document.getElementById('ng-search-results-link');
  var noResultsQuery = document.getElementById('ng-search-no-results-query');
  var debounceTimer;

  function openSearch() {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { input.focus(); }, 100);
  }

  function closeSearch() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    input.value = '';
    showDefault();
  }

  function showDefault() {
    defaultContent.classList.remove('ng-hidden');
    resultsDiv.classList.add('ng-hidden');
    noResultsDiv.classList.add('ng-hidden');
    if (clearBtn) clearBtn.classList.add('ng-hidden');
  }

  function showResults(html, count, query) {
    defaultContent.classList.add('ng-hidden');
    noResultsDiv.classList.add('ng-hidden');
    resultsDiv.classList.remove('ng-hidden');
    if (clearBtn) clearBtn.classList.remove('ng-hidden');
    resultsCount.textContent = count > 8 ? '8+' : count;
    resultsLink.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
    resultsProducts.innerHTML = html;
  }

  function showNoResults(query) {
    defaultContent.classList.add('ng-hidden');
    resultsDiv.classList.add('ng-hidden');
    noResultsDiv.classList.remove('ng-hidden');
    if (clearBtn) clearBtn.classList.remove('ng-hidden');
    noResultsQuery.textContent = query;
  }

  function doSearch(query) {
    if (!query.trim()) {
      showDefault();
      return;
    }

    // Use Section Rendering API — fetches rendered HTML from Shopify
    fetch('/search?q=' + encodeURIComponent(query) + '&type=product&section_id=ng-search-overlay-results')
      .then(function(res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function(html) {
        // Parse the response to extract product cards and count
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var dataDiv = doc.getElementById('ng-overlay-data');
        if (!dataDiv) throw new Error('no data');

        var count = parseInt(dataDiv.getAttribute('data-count')) || 0;
        var items = dataDiv.querySelectorAll('.ng-search__result-item');

        if (items.length > 0) {
          showResults(dataDiv.innerHTML, count, query);
        } else {
          showNoResults(query);
        }
      })
      .catch(function() {
        showNoResults(query);
      });
  }

  // Open triggers
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      openSearch();
    });
  });

  // Close
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);

  // Clear
  if (clearBtn) clearBtn.addEventListener('click', function() {
    input.value = '';
    input.focus();
    showDefault();
  });

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('active')) {
      closeSearch();
    }
  });

  // Live search on input
  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var val = input.value;
    if (clearBtn) {
      clearBtn.classList.toggle('ng-hidden', val.length === 0);
    }
    debounceTimer = setTimeout(function() {
      doSearch(val);
    }, 300);
  });

  // Enter to go to search page
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var q = input.value.trim();
      if (q) window.location.href = ngLocaleRoot() + 'search?q=' + encodeURIComponent(q) + '&type=product';
    }
  });

  // Trending search clicks
  document.querySelectorAll('.ng-search__trending-tag').forEach(function(tag) {
    tag.addEventListener('click', function() {
      var term = this.getAttribute('data-search-term') || this.textContent.trim();
      input.value = term;
      if (clearBtn) clearBtn.classList.remove('ng-hidden');
      doSearch(term);
    });
  });

  // Close search when clicking result links
  overlay.addEventListener('click', function(e) {
    var link = e.target.closest('[data-ng-close-search]');
    if (link) closeSearch();
  });
})();
